<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import AgentAPI from 'dashboard/api/agents';
import Button from 'dashboard/components-next/button/Button.vue';
import MasterPasswordFields from './MasterPasswordFields.vue';
import { validAgentPassword, agentPasswordError } from './agentPassword';
const props = defineProps({ agent: { type: Object, required: true } });
const emit = defineEmits(['close', 'done']);
const { t } = useI18n();
const password = ref('');
const confirmation = ref('');
const saving = ref(false);
const valid = computed(() =>
  validAgentPassword(password.value, confirmation.value)
);
const submit = async () => {
  if (!valid.value || saving.value) return;
  saving.value = true;
  try {
    await AgentAPI.resetPassword(props.agent.id, {
      password: password.value,
      password_confirmation: confirmation.value,
    });
    password.value = '';
    confirmation.value = '';
    useAlert(t('AGENT_PASSWORD.SUCCESS'));
    emit('done');
  } catch (error) {
    useAlert(agentPasswordError(error, t));
  } finally {
    saving.value = false;
  }
};
</script>

<template>
  <div class="flex flex-col overflow-auto">
    <woot-modal-header
      :header-title="t('AGENT_PASSWORD.TITLE')"
      :header-content="t('AGENT_PASSWORD.DESCRIPTION')"
    />
    <form class="space-y-5" @submit.prevent="submit">
      <div class="rounded-xl border border-n-weak bg-n-alpha-1 p-3">
        <p class="!m-0 font-medium text-n-slate-12">{{ agent.name }}</p>
        <p class="!mb-0 !mt-1 break-all text-sm text-n-slate-11">
          {{ agent.email }}
        </p>
      </div>
      <MasterPasswordFields
        v-model:password="password"
        v-model:confirmation="confirmation"
      />
      <p class="rounded-lg bg-n-alpha-1 p-3 text-sm text-n-slate-11">
        {{ t('AGENT_PASSWORD.SESSION_NOTICE') }}
      </p>
      <div class="flex justify-end gap-2">
        <Button
          type="button"
          faded
          slate
          :label="t('AGENT_PASSWORD.CANCEL')"
          :disabled="saving"
          @click="emit('close')"
        />
        <Button
          type="submit"
          :label="t('AGENT_PASSWORD.SUBMIT')"
          :disabled="!valid || saving"
          :is-loading="saving"
        />
      </div>
    </form>
  </div>
</template>
